import { Routes } from '@angular/router';

export const MORTALIDADE_ROUTES: Routes = [
	{
		path: 'mortalidade',
		loadComponent: () => import('./feature-mortalidade/mortalidade').then((m) => m.Mortalidade),
		data: { title: 'Mortalidade' },
	},
];
